module.exports = __webpack_public_path__ + "img/heart_selected.98a47b81.svg";